import { CurrencyPipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { CurrencyModel } from 'src/app/_models/currency.model';
import {CurrenciesEntitiesState} from '../../../states/common/currencies-entities.state';

@Pipe ({
    name: 'discountDisplay'
 })
 export class DiscountDisplayPipe implements PipeTransform {

    constructor(
            @Inject(LOCALE_ID) private locale: string,
            public currencies: CurrenciesEntitiesState
        ) {}

    transform(discount: number, isPercentage: boolean, currencyId = new CurrencyModel().id) {

        if (!discount){
            return 'NONE';
        } else if (isPercentage) {
            return `${discount}%`;
        } else {
            return new CurrencyPipe(this.locale).transform(discount, this.currencies.entities[currencyId]?.symbol);
        }
    }

 }
